import Logo from '@/features/settings/components/templates/logo';

export const LogoContainer = () => {
  return <Logo />;
};
